module.exports = __webpack_public_path__ + "static/shop-button-click-12b416c2eea8738773fabf73f56655d3.mp3";